<template>
  <page>
    <v-card>
      <v-card-title>
        <div>
          <div class="headline">Member Groups Listing</div>
        </div>
        <v-spacer></v-spacer>
        <v-flex xs6>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-flex>
      </v-card-title>
      <v-flex xs12 class="mt-3">
        <message :messages="messages"></message>
      </v-flex>
      <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="groupId" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="items" slot-scope="props">
          <td>{{ props.item.groupId }}</td>
          <td class="text-xs-left">{{ props.item.groupDesc }}</td>
          <td class="text-xs-left">{{ formatTextLength(props.item.groupDeclaration) }}</td>
          <td class="text-xs-left">{{ props.item.enableB2CReg }}</td>
          <td class="text-xs-left">{{ props.item.restrictedGroup }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" query @query="doQuery(props)" :review="checkAccess(['memberReview'])" @review="doReview(props)" :remove="checkAccess(['memberReview'])" @remove="doPromptRemove(props.item)" :loading="loading"></table-action>
          </td>
        </template>
      </v-data-table>
      <v-card-text>
        <v-btn slot="activator" color="primary" dark class="mb-2" @click="doNew()" v-if="checkAccess(['memberReview'])">
          Add Member Group
          <v-icon right>mdi-account-card-details</v-icon>
        </v-btn>
      </v-card-text>
      <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Member Group?
        <div class="title">{{deleteUsrMemberGrp}}</div>
      </confirm>
    </v-card>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      headers: [
        { text: 'Group ID', align: 'left', value: 'groupId', sortable: false },
        { text: 'Group Description', align: 'left', value: 'groupDesc', sortable: false },
        { text: 'Group Declaration', align: 'left', value: 'groupDeclaration', sortable: false },
        { text: 'Enabled for B2C Registration', align: 'left', value: 'enableB2CReg', sortable: false },
        { text: 'Restricted Group', align: 'left', value: 'restrictedGroup', sortable: false },
        TableConst.tableActionHeader
      ],
      totalItems: 0,
      loading: false,
      items: [],
      promptRemove: false,
      selectedUsrMemberGrp: undefined,
      deleteUsrMemberGrp: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    async doInit() {
      await this.queryMemberGroups()
    },
    async queryMemberGroups() {
      const apiURI = this.$store.state.adminMember.menu.memberGroups
      if (apiURI) {
        try {
          this.loading = true
          const result = await this.$http.get(apiURI)
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((memberGroup) => {
                const convertMemberGroup = {
                  groupId: memberGroup.groupId,
                  groupDesc: memberGroup.groupDesc,
                  groupDeclaration: memberGroup.groupDeclaration,
                  enableB2CReg: this.formatBoolean(memberGroup.enableB2CReg),
                  restrictedGroup: this.formatBoolean(memberGroup.restrictedGroup)
                }
                this.items.push(convertMemberGroup)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doNew() {
      this.resetMessages()
      this.$router.push({ name: 'memberGroupReview', params: { groupId: 'new' } })
    },
    doQuery(data) {
      this.resetMessages()
      if (data && data.item && data.item.groupId) {
        this.$router.push({ name: 'memberGroupQuery', params: { groupId: data.item.groupId } })
      }
    },
    doReview(data) {
      this.resetMessages()
      if (data && data.item && data.item.groupId) {
        this.$router.push({ name: 'memberGroupReview', params: { groupId: data.item.groupId } })
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedUsrMemberGrp = data
        this.deleteUsrMemberGrp = data.groupId + ' - ' + data.groupDesc
      }
    },
    async doRemove() {
      this.resetMessages()
      const apiURI = this.$store.state.adminMember.menu.memberGroupDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          groupId: this.selectedUsrMemberGrp.groupId
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.queryMemberGroups()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
